import styled from 'styled-components'

export const Text = styled.p`
  font-size: 13px;
  margin: 0;
  text-align: right;
`
export const Label = styled.p`
  font-size: 13px;
  margin: 0;
  color: ${({ theme }) => theme.colors.primary};
`
export const Title = styled.h3`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;

  font-size: 22px;
  font-weight: 700;
  margin-bottom: 2px;
  color: ${({ theme }) => theme.colors.primary};

  max-width: 260px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`
export const SubTitle = styled.h4`
  font-size: 10px;
  margin: 0;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.primary};
`
export const TableRowContainer = styled.div`
  display: flex;
  justify-content: space-between;
`
export const TableColWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 15px;

  &:first-child {
    background-color: ${({ theme }) => `${theme.colors.secondary}10`};
    border-bottom: 2px solid ${({ theme }) => theme.colors.backgroundLite};
    border-radius: 10px 10px 0 0;
    gap: 5px;
    & button {
      visibility: ${({ pending }) => !pending && 'hidden'};
      color: ${({ theme }) => theme.colors.brand} !important;
      border-color: ${({ theme }) => theme.colors.brand} !important;
    }
  }
  &:last-child {
    background-color: ${({ theme }) => theme.colors.background};
    border-radius: 0 0 10px 10px;
  }

  &:last-child {
    border-top: 2px solid ${({ theme }) => theme.colors.backgroundLite};
    & div > p {
      font-size: 13px;
      font-weight: 100;
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`
